<template>
    <div id="item-container">
        <b-row>
            <b-col>
                <MdTitle
                    v-bind:Text="
                        this.editMode
                            ? `${$t('Shared.Edit')} ${$t('Shared.Therapy')}`
                            : $t('MdNote.AddTherapy')
                    "
                />
            </b-col>
        </b-row>

        <b-row>
            <b-col sm="12" md="12" lg="12">
                <div class="accordion" role="tablist">
                    <b-card no-body class="noteSearchPanel mb-0">
                        <b-card-header header-tag="header" class="p-0" role="tab">
                            <b-button
                                block
                                class="collapseBTN text-truncate"
                                v-on:click="Accordion1Click"
                            >
                                <b-icon icon="arrow-down-right-circle" aria-hidden="true"></b-icon>
                                {{ $t('Shared.General') }}
                            </b-button>
                        </b-card-header>
                        <b-collapse
                            id="accordion-1"
                            visible
                            accordion="ClinicalNotes"
                            role="tabpanel"
                            v-show="ShowFilter && !ShowBilling"
                            v-on:click="ShowFilter = true"
                        >
                            <b-card-body class="p-1">
                                <b-card-text class="notesPanelsChartReview cutescroll">
                                    <b-row>
                                        <b-col lg="3" md="3" sm="12">
                                            <MdEdit
                                                v-bind:Label="$t('Shared.Code')"
                                                v-bind:Name="'Code'"
                                                v-bind:TypeProp="'text'"
                                                v-bind:MaxLengthProp="15"
                                                v-model="therapy.code"
                                                v-bind:isRequired="true"
                                                v-bind:isReadOnly="isReadOnly"
                                                v-bind:Id="'input_code'"
                                            />
                                        </b-col>
                                        <b-col lg="3" md="3" sm="12">
                                            <MdEdit
                                                v-bind:Label="$t('Shared.Name')"
                                                v-bind:TypeProp="'text'"
                                                v-bind:Name="'name'"
                                                v-bind:MaxLengthProp="50"
                                                v-model="therapy.name"
                                                v-bind:isReadOnly="isReadOnly"
                                                v-bind:isRequired="true"
                                                v-bind:Id="'input_name'"
                                            >
                                            </MdEdit>
                                        </b-col>
                                        <b-col lg="3" md="3" sm="12">
                                            <MdEdit
                                                v-bind:Label="$t('therapyid')"
                                                v-bind:TypeProp="'text'"
                                                v-bind:Name="'therapyid'"
                                                v-bind:MaxLengthProp="16"
                                                v-model="therapy.therapyid"
                                                v-bind:isReadOnly="isReadOnly"
                                                v-bind:Id="'input_therapyid'"
                                            >
                                            </MdEdit>
                                        </b-col>
                                        <b-col lg="3" md="3" sm="12">
                                            <MdRadioGroup
                                                v-bind:Label="$t('insuranceSetup.Part')"
                                                v-model="therapy.medpart"
                                                v-bind:Options="optionsPart"
                                                v-bind:Name="'radio-inline'"
                                                v-bind:isReadOnly="isReadOnly"
                                            />
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col md="3" lg="3" sm="12">
                                            <MdCheckBox
                                                v-bind:Label="$t('therapy.UseTx')"
                                                v-bind:Name="'checkbox-Unwrapped'"
                                                v-bind:ClassProp="'AlignCheck'"
                                                v-bind:CheckedValue="true"
                                                v-bind:UncheckedValue="false"
                                                v-model="therapy.canUseInTreatmentPlan"
                                                v-bind:isReadOnly="isReadOnly"
                                            />
                                        </b-col>
                                        <b-col lg="3" md="3" sm="12">
                                            <MdSelect
                                                v-bind:Label="$t('therapy.CanUsNote')"
                                                v-bind:Options="useInNoteList"
                                                v-bind:FieldDescription="'name'"
                                                v-bind:FieldCode="'code'"
                                                v-bind:Model="noteStatusVModel"
                                                v-bind:Multiple="false"
                                                :IsDisabled="isReadOnly"
                                                :Input="changeDropDownNoteStatus"
                                            />
                                        </b-col>
                                        <b-col lg="3" md="3" sm="12">
                                            <MdEdit
                                                v-bind:Label="$t('therapy.MaxDaUn')"
                                                v-bind:Name="'maxDailyUnit'"
                                                v-bind:TypeProp="'number'"
                                                v-model="therapy.maxDailyUnit"
                                                v-bind:isReadOnly="isReadOnly"
                                                v-bind:Min="'0'"
                                                v-bind:StepProp="'1'"
                                                v-bind:Max="'10'"
                                                v-bind:Id="'input_maxDailyUnit'"
                                            />
                                        </b-col>
                                        <b-col lg="3" md="3" sm="12">
                                            <MdEdit
                                                v-bind:Label="$t('therapy.MinPeUn')"
                                                v-bind:TypeProp="'number'"
                                                v-bind:Name="'timePerUnit'"
                                                v-model="therapy.timePerUnit"
                                                v-bind:isReadOnly="isReadOnly"
                                                v-bind:Min="'0'"
                                                v-bind:StepProp="'1'"
                                                v-bind:Max="'10'"
                                                v-bind:Id="'input_timePerUnit'"
                                            >
                                            </MdEdit>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col lg="3" md="3" sm="12">
                                            <MdEdit
                                                v-bind:Label="$t('therapy.MinMiss')"
                                                v-bind:TypeProp="'number'"
                                                v-bind:Name="'minimumMin'"
                                                v-model="therapy.minimumMin"
                                                v-bind:isReadOnly="isReadOnly"
                                                v-bind:Min="'0'"
                                                v-bind:StepProp="'1'"
                                                v-bind:Max="'10'"
                                                v-bind:Id="'input_minimumMin'"
                                            >
                                            </MdEdit>
                                        </b-col>
                                        <b-col lg="3" md="3" sm="12">
                                            <MdEdit
                                                v-bind:Label="$t('therapy.MaxMiss')"
                                                v-bind:TypeProp="'number'"
                                                v-bind:Name="'maximumMin'"
                                                v-model="therapy.maximumMin"
                                                v-bind:isReadOnly="isReadOnly"
                                                v-bind:Min="'0'"
                                                v-bind:StepProp="'1'"
                                                v-bind:Max="'10'"
                                                v-bind:Id="'input_maximumMin'"
                                            >
                                            </MdEdit>
                                        </b-col>
                                        <b-col lg="3" md="3" sm="12">
                                            <MdLookup
                                                v-bind:ModelCode="therapy.category"
                                                v-bind:ModelDescription="categoryName"
                                                v-bind:Label="$t('Shared.Category')"
                                                v-bind:RefCode="'category'"
                                                v-bind:Api="'Categories'"
                                                v-bind:FieldCode="'code'"
                                                v-bind:FieldDescription="'name'"
                                                :SearchTitle="$t('Shared.Category')"
                                                :GetValues="onCodeConditionOk"
                                                :InvalidFeedback="$t('ModalCategory.fBakInvCatMsg')"
                                                :SearchFieldCode="'Code'"
                                            />
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col md="3" lg="3" sm="12">
                                            <MdCheckBox
                                                v-bind:Label="$t('therapy.NoShowR')"
                                                v-bind:Name="'checkbox-notshow'"
                                                v-bind:ClassProp="'AlignCheck'"
                                                v-bind:CheckedValue="true"
                                                v-bind:UncheckedValue="false"
                                                v-model="therapy.notshowinreport"
                                                v-bind:isReadOnly="isReadOnly"
                                            />
                                        </b-col>
                                        <b-col md="3" lg="3" sm="12">
                                            <MdCheckBox
                                                v-bind:Label="$t('therapy.IsComm')"
                                                v-bind:Name="'checkbox-used'"
                                                v-bind:ClassProp="'AlignCheck'"
                                                v-bind:CheckedValue="true"
                                                v-bind:UncheckedValue="false"
                                                v-model="therapy.isCommonlyUsed"
                                                v-bind:isReadOnly="isReadOnly"
                                            />
                                        </b-col>
                                    </b-row>
                                    <MdTitle
                                        v-bind:Text="$t('Shared.Frequency')"
                                        v-bind:isSubtitle="true"
                                        v-bind:Name="'T_TitleSearch'"
                                    />
                                    <b-row>
                                        <b-col lg="12" md="12" sm="12">
                                            <b-row class="mb-2">
                                                <b-col lg="12" md="12" sm="12">
                                                    <b-form-checkbox
                                                        @change="toggleSelectAll($event)"
                                                        v-model="allSelected"
                                                        style="color: #666; font-size: 0.875rem; font-weight: 400"
                                                    >
                                                        <span style="position:relative; top:4px">{{
                                                            $t('Shared.SelectAll')
                                                        }}</span>
                                                    </b-form-checkbox>
                                                </b-col>
                                            </b-row>

                                            <MdCheckListBox2
                                                v-model="selectedOptions"
                                                v-bind:OnChangeProp="updateSelectAll"
                                                v-bind:Options="options"
                                                v-bind:Height="'65px'"
                                                v-bind:columnCount="7"
                                                :textField="'name'"
                                                :valueField="'value'"
                                                style="margin-bottom: 1em;
                "
                                            />
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col lg="12" md="12" sm="12">
                                            <MdMemo
                                                v-bind:Label="$t('Shared.Description')"
                                                v-bind:Name="'description'"
                                                v-bind:Rows="'5'"
                                                v-bind:MaxRows="'6'"
                                                v-bind:MaxLength="'500'"
                                                v-bind:VisibleLabel="true"
                                                v-model="therapy.description"
                                            />
                                        </b-col>
                                    </b-row>
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="openNotesPanel mb-0">
                        <b-card-header header-tag="header" class="p-0" role="tab">
                            <b-button block v-on:click="ClickBtnAccordion2" class="collapseBTN">
                                <b-icon icon="arrow-down-right-circle" aria-hidden="true"></b-icon>
                                {{ $t('Shared.Billing') }}
                            </b-button>
                        </b-card-header>
                        <b-collapse
                            id="accordion-2"
                            accordion="ClinicalNotes"
                            role="tabpanel"
                            v-show="ShowBilling && !ShowFilter"
                            v-on:click="ShowBilling = true"
                            :class="ClassAccordion"
                            ref="a2"
                        >
                            <b-card-body class="p-1">
                                <b-card-text class="notesPanels">
                                    <b-row>
                                        <b-col class="col-sm-12 col-md-3">
                                            <MdButton
                                                v-bind:Label="$t('Shared.Add')"
                                                v-bind:ClassProp="
                                                    this.isReadOnly
                                                        ? 'btn btn-primary my-3 btn-block'
                                                        : 'btn btn-primary my-3 btn-block btn-login'
                                                "
                                                v-bind:IconClass="'ti-plus pr-1'"
                                                v-on:click="addHandler"
                                                v-bind:isReadOnly="this.isReadOnly"
                                            >
                                            </MdButton>
                                        </b-col>
                                        <b-col class="col-sm-12 col-md-9">
                                            <div
                                                class="textlabel"
                                                :data-label="this.$t('Shared.SearchElements')"
                                            >
                                                <div class="input-group" dir="ltr">
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        :dir="dirInput"
                                                        v-model="searchBill"
                                                        @keyup.enter="findBilling"
                                                    />
                                                    <div class="input-group-append">
                                                        <MdButton
                                                            v-bind:Name="'btnsearchinput'"
                                                            v-bind:VariantProp="
                                                                'btn btn-sm search-attached'
                                                            "
                                                            v-bind:IconClass="'mdi mdi-magnify'"
                                                            v-on:click="findBilling"
                                                        >
                                                        </MdButton>
                                                    </div>
                                                </div>
                                            </div>
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col md="9" sm="12" lg="6">
                                            <MdLookup
                                                v-bind:ModelCode="search.insurance"
                                                v-bind:ModelDescription="searchInsuranceName"
                                                v-bind:Label="$tc('Insurance.Insurance', 1)"
                                                v-bind:RefCode="'InsuranceCode'"
                                                v-bind:Api="'Insurances'"
                                                v-bind:FieldCode="'insurancecode'"
                                                v-bind:FieldDescription="'company'"
                                                :SearchTitle="$tc('Insurance.Insurance', 1)"
                                                :GetValues="getInsuranceCodeValues"
                                                :InvalidFeedback="
                                                    $t('Insurance.InvalidInsuranceCode')
                                                "
                                                :SearchFieldCode="'InsuranceCode'"
                                                v-bind:Fields="insuranceFields"
                                            />
                                        </b-col>
                                        <b-col lg="3" md="3" sm="12">
                                            <MdSelect
                                                v-bind:Label="$t('Shared.Status')"
                                                v-bind:Options="statusOptions"
                                                v-bind:FieldDescription="'name'"
                                                v-bind:FieldCode="'value'"
                                                v-bind:Model="statusModel"
                                                v-bind:Multiple="false"
                                                :Input="changeDropDownStatus"
                                            />
                                        </b-col>
                                    </b-row>

                                    <b-row class="mt-4">
                                        <b-col>
                                            <MdTablePaginationClient
                                                v-bind:fields="fields"
                                                v-bind:items="filteredTherapyBillingCodes"
                                                v-bind:totalRows="totalRows"
                                                v-bind:isReadOnly="isReadOnly"
                                                v-bind:showMessageIsEmpty="showMessageIsEmpty"
                                                v-bind:currentPage="currentPage"
                                                v-bind:perPage="perPage"
                                                v-bind:pageOptions="pageOptions"
                                                :onRowSelected="onRowSelected"
                                                :onFiltered="onFiltered"
                                                :pageChanged="pageChanged"
                                                :perPageFunction="PerPageFunction"
                                                :RowClick="rowClickHandler"
                                                :VisibleDeleteIcon="true"
                                                :deleteIconEvent="RemoveBillingCode"
                                                :VisibleEditIcon="true"
                                                :editIconEvent="EditBillingCode"
                                            >
                                            </MdTablePaginationClient>
                                        </b-col>
                                    </b-row>
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </b-col>
        </b-row>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:Name="'btnBack'"
                v-bind:TextToolTip="$t('ePharmacyItemsReceived.BackToList')"
                v-on:click="goBack"
                v-bind:ClassProp="'mx-2 btn-login'"
            />
            <MdButton
                v-bind:Label="$t('Shared.Save')"
                v-bind:ClassProp="this.isReadOnly ? 'primary mx-2' : 'primary btn-login mx-2'"
                v-on:click="SaveOrEdit"
                v-bind:isReadOnly="this.isReadOnly"
                v-bind:Name="'btn_save_inventory_item'"
            />
        </div>

        <therapyBillingEditDlg
            v-bind:visible="visibleEditDialog"
            v-model="editableItem"
            @close="closeHandler"
            @ok="okHandler"
            v-bind:baseFieldsIns="BaseFieldsIns"
            v-bind:baseFieldsModifier="BaseFieldsModifier"
            :checkOverlapping="checkOverlapping"
        >
        </therapyBillingEditDlg>
    </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import { EventBus } from '@/event-bus.js';
import TherapyService from '@/services/therapy.service';
import EmployeeService from '@/services/employee.service';
import TherapyCategoriesService from '@/services/therapycategories.service';
import therapyBillingEditDlg from './therapyBillingEditDlg';
import Utils from '@/common/utils.js';
import InsuranceService from '@/services/insurance.service';
import CptService from '@/services/cpt.service';
import ModifierService from '@/services/modifier.service';
import ValueCodeService from '@/services/valuescodes.service';
import PlaceOfServiceService from '@/services/placeofservice.service';
import EnumService from '@/services/enum.service';
import moment from 'moment';

let elemSaveBtn = '';
export default {
    beforeRouteLeave(to, from, next) {
        if (!this.isReadOnly && this.pendingChanges) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                    title: this.$t('therapyCatListing.Title'),
                    okTitle: this.$t('Shared.BtnSave'),
                    cancelTitle: this.$t('Shared.BtnDismiss'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (!value) {
                        next();
                    } else {
                        this.SaveOrEdit();
                        next();
                    }
                });
        } else {
            next();
        }
    },

    mixins: [ShowMessage, DBFunctions],
    props: ['editMode'],
    components: {
        therapyBillingEditDlg
    },
    data() {
        return {
            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                Mode: this.editMode,
                favButtonAtion: false
            },
            visibleEditDialog: false,
            isReadOnly: false,
            isEditable: true,
            therapy: {
                code: null,
                name: '',
                medpart: '',
                therapyBillingCodes: []
            },
            optionsPart: [
                { text: this.$t('insuranceSetup.oPart.PartA'), value: 'A' },
                { text: this.$t('insuranceSetup.oPart.PartB'), value: 'B' }
            ],
            useInNoteList: [
                { code: 'A', name: this.$t('Shared.All') },
                { code: 'S', name: this.$t('Schd') },
                { code: 'U', name: this.$t('Unschd') },
                { code: 'N', name: this.$t('insuranceSetup.oPList.n') }
            ],
            BaseFieldsModifier: [
                { key: 'code', sortable: true, label: this.$t('Shared.Code') },
                { key: 'description', sortable: true, label: this.$t('Shared.Description') }
            ],
            TherapistVmodel: {},
            TherapistList: [],
            categoryName: '',
            options: [
                { value: 'Mon', name: this.$t('Layout.dDay.Monday') },
                { value: 'Tue', name: this.$t('Layout.dDay.Tuesday') },
                { value: 'Wed', name: this.$t('Layout.dDay.Wednesday') },
                { value: 'Thu', name: this.$t('Layout.dDay.Thursday') },
                { value: 'Fri', name: this.$t('Layout.dDay.Friday') },
                { value: 'Sat', name: this.$t('Layout.dDay.Saturday') },
                { value: 'Sun', name: this.$t('Layout.dDay.Sunday') }
            ],
            selectedOptions: [],
            allSelected: false,
            isIndeterminate: false,
            BaseFieldsIns: [
                { key: 'insurancecode', sortable: true, label: this.$t('Shared.Code') },
                { key: 'company', sortable: true, label: this.$t('employee.Company') }
            ],
            BaseModifier: [
                { key: 'code', sortable: true, label: this.$t('Shared.Code') },
                { key: 'description', sortable: true, label: this.$t('Shared.Description') }
            ],
            fields: [
                {
                    key: 'insuranceCode',
                    sortable: true,
                    label: this.$t('Shared.InsuranceCode'),
                    class: 'text-left hidden'
                },
                {
                    key: 'insuranceName',
                    sortable: true,
                    label: this.$t('Shared.colInsuranceName'),
                    class: 'text-left'
                },
                {
                    key: 'startDate',
                    sortable: true,
                    label: this.$t('Shared.StartDate'),
                    class: 'text-center',
                    formatter: value => (value ? Utils.formatterDateToString(value) : '')
                },
                {
                    key: 'endDate',
                    sortable: true,
                    label: this.$t('Shared.EndDate'),
                    class: 'text-center',
                    formatter: value => (value ? Utils.formatterDateToString(value) : '')
                },
                {
                    key: 'cpt',
                    sortable: true,
                    label: this.$t('Shared.CPT'),
                    class: 'text-left'
                },
                //{ key: 'cpt', sortable: true, label: this.$t('Shared.CPT'), class: 'text-left' },
                {
                    key: 'hcPcsCode',
                    sortable: true,
                    label: this.$t('Shared.HCPCSCode'),
                    class: 'text-left'
                },
                /*{
                    key: 'dhcpcs',
                    sortable: true,
                    label: this.$t('Shared.HCPCS'),
                    class: 'text-left'
                },*/
                {
                    key: 'modifier1',
                    sortable: true,
                    label: this.$t('PatientClaimList.Modifier', { num: 1 }),
                    class: 'text-left'
                },
                /*{
                    key: 'dmodifier1',
                    sortable: true,
                    label: this.$t('PatientClaimList.Modifier', { num: 1 }),
                    class: 'text-left'
                },*/
                {
                    key: 'modifier2',
                    sortable: true,
                    label: this.$t('PatientClaimList.Modifier', { num: 2 }),
                    class: 'text-left'
                },
                {
                    key: 'pos',
                    sortable: true,
                    label: this.$t('PatientClaimList.Pos'),
                    class: 'text-left'
                },
                {
                    key: 'rateAmt',
                    sortable: true,
                    label: this.$t('dcsview.Rate'),
                    class: 'text-right'
                },
                {
                    key: 'status',
                    sortable: true,
                    label: this.$t('Shared.Status'),
                    class: 'text-center',
                    formatter: value => (value ? value : '')
                }
            ],
            insuranceFields: [
                {
                    key: 'company',
                    sortable: true,
                    label: this.$t('Shared.colInsuranceName'),
                    class: 'text-left'
                },
                {
                    key: 'insurancecode',
                    sortable: true,
                    label: this.$t('Shared.InsuranceCode'),
                    class: 'text-left'
                },
                {
                    key: 'insuranceTypeDescription',
                    sortable: true,
                    label: this.$t('Shared.InsType'),
                    class: 'text-left'
                },
                {
                    key: 'categoryDescription',
                    sortable: true,
                    label: this.$t('Shared.Category'),
                    class: 'text-left'
                },
                {
                    key: 'contact',
                    sortable: true,
                    label: this.$tc('Contact.Contact'),
                    class: 'text-left'
                },
                {
                    key: 'address1',
                    sortable: true,
                    label: this.$t('Shared.Address1'),
                    class: 'text-left'
                },
                {
                    key: 'address2',
                    sortable: true,
                    label: this.$t('Shared.Address2'),
                    class: 'text-left'
                },
                { key: 'city', sortable: true, label: this.$t('Shared.City'), class: 'text-left' }
            ],
            editableItem: null,
            // totalRows: 0,
            // showMessageIsEmpty: false,
            pageOptions: [5, 10, 15],
            perPage: 10,
            currentPage: 1,
            isValidReceivedDate: true,
            editableItemIndex: -1,
            searchBill: '',
            search: {
                billing: '',
                insurance: '',
                status: ''
            },
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            searchInsuranceName: '',
            statusOptions: EnumService.StatusInsurance,
            statusModel: { value: '', name: this.$t('Shared.All') },
            ShowFilter: true,
            ShowBilling: false,
            ClassAccordion: 'show',
            noteStatusVModel: { code: '', name: '' }
        };
    },
    watch: {
        selectedOptions: {
            handler: function(newVal) {
                if (newVal.length === this.options.length) {
                    // All selected
                    this.allSelected = true;
                    this.isIndeterminate = false;
                } else if (newVal.length === 0) {
                    // Non selected
                    this.allSelected = false;
                    this.isIndeterminate = false;
                } else {
                    // Some selected (in beetween state)
                    this.allSelected = false;
                    this.isIndeterminate = true;
                }
            },
            immediate: true, // It is executed immediately upon creation
            deep: true
        }
    },
    computed: {
        filteredTherapyBillingCodes() {
            const search = (this.search.billing || '').trim().toLowerCase();
            const searchInsurance = (this.search.insurance || '').trim().toLowerCase();
            const searchStatus = (this.search.status || '').trim().toLowerCase();
            const list = this.therapy?.therapyBillingCodes || [];

            if (!search && !searchInsurance && !searchStatus) {
                return list;
            }

            return list.filter(item => {
                const insuranceName = (item.insuranceName || '').toLowerCase();
                const insuranceCode = (item.insuranceCode || '').toLowerCase();
                const dcpt = (item.dcpt || '').toLowerCase();
                const dhcpcs = (item.dhcpcs || '').toLowerCase();
                const dmodifier1 = (item.dmodifier1 || '').toLowerCase();
                const startDate = item.startDate ? Utils.formatterDateToString(item.startDate) : '';
                const endDate = item.endDate ? Utils.formatterDateToString(item.endDate) : '';
                const insuranceStatus = (item.status || '').toLowerCase();

                const searchIncludes = !search
                    ? true
                    : insuranceName.includes(search) ||
                      insuranceCode.includes(search) ||
                      dcpt.includes(search) ||
                      dhcpcs.includes(search) ||
                      dmodifier1.includes(search) ||
                      startDate.includes(search) ||
                      endDate.includes(search);
                const searchEqual = !searchInsurance ? true : insuranceCode === searchInsurance;
                const searchOther = !searchStatus ? true : insuranceStatus === searchStatus;

                return searchIncludes && searchEqual && searchOther;
            });
        },

        totalRows() {
            return this.filteredTherapyBillingCodes.length;
        },

        showMessageIsEmpty() {
            return this.totalRows === 0;
        }
    },
    methods: {
        goBack() {
            this.$router.push({ name: 'TherapyListing' });
        },

        SaveOrEdit() {
            if (!this.isReadOnly) {
                elemSaveBtn.setAttribute('disabled', '');

                if (this.editMode) {
                    this.update();
                } else {
                    this.save();
                }
            }
        },

        ChangeDropDownTherapist(value) {
            this.therapy.therapistcode = value ? value.code : '';
        },

        save() {
            const dataToSend = this.convertBoolToYN(this.therapy);
            TherapyService.add(dataToSend)
                .then(response => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );

                        this.goBack();
                    }
                })
                .catch(error => {
                    elemSaveBtn.removeAttribute('disabled');
                    this.showResponseErrorMessage(error);
                });
        },

        update() {
            const dataToSend = this.convertBoolToYN(this.therapy);
            TherapyService.update(this.$route.params.id, dataToSend)
                .then(response => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );

                        this.goBack();
                    }
                })
                .catch(error => {
                    elemSaveBtn.removeAttribute('disabled');
                    this.showResponseErrorMessage(error);
                });
        },

        async getTherapy() {
            if (this.editMode) {
                try {
                    const response = await TherapyService.get(this.$route.params.id);

                    if (response.status == '200' && response.data) {
                        // PRIMERO convertir Y/N a booleanos
                        this.therapy = this.convertYNObj(response.data);

                        // AHORA sí usar los datos ya convertidos
                        this.selectedOptions = [];
                        if (this.therapy.mon) this.selectedOptions.push('Mon');
                        if (this.therapy.tue) this.selectedOptions.push('Tue');
                        if (this.therapy.wed) this.selectedOptions.push('Wed');
                        if (this.therapy.thu) this.selectedOptions.push('Thu');
                        if (this.therapy.fri) this.selectedOptions.push('Fri');
                        if (this.therapy.sat) this.selectedOptions.push('Sat');
                        if (this.therapy.sun) this.selectedOptions.push('Sun');

                        // Enriquecer los billing codes con sus descripciones
                        if (
                            this.therapy.therapyBillingCodes &&
                            this.therapy.therapyBillingCodes.length > 0
                        ) {
                            // Crear una copia para no modificar el original directamente
                            const originalCodes = [...this.therapy.therapyBillingCodes];
                            const enrichedCodes = await this.enrichBillingCodesWithDescriptions(
                                originalCodes
                            );
                            this.therapy.therapyBillingCodes = enrichedCodes;
                        }

                        // this.totalRows = this.therapy.therapyBillingCodes.length;
                        // this.showMessageIsEmpty = this.totalRows === 0;
                        const modelStatus = this.useInNoteList.find(
                            x => this.therapy.noteStatus === x.code
                        );

                        if (modelStatus) {
                            this.noteStatusVModel.code = modelStatus.code;
                            this.noteStatusVModel.name = modelStatus.name;
                        }
                    }
                } catch (error) {
                    this.showResponseErrorMessage(error);
                }
            }
        },
        // Método auxiliar para convertir Y/N a booleanos
        convertYNObj(obj) {
            if (typeof obj !== 'object' || obj === null) return obj;

            if (Array.isArray(obj)) {
                return obj.map(item => this.convertYNObj(item));
            }

            const result = {};
            for (const [key, value] of Object.entries(obj)) {
                if (typeof value === 'string' && value === 'Y') {
                    result[key] = true;
                } else if (typeof value === 'string' && value === 'N') {
                    result[key] = false;
                } else if (typeof value === 'object' && value !== null) {
                    result[key] = this.convertYNObj(value);
                } else {
                    result[key] = value;
                }
            }
            return result;
        },

        // Convertir booleanos a "Y"/"N"
        convertBoolToYN(obj) {
            if (typeof obj !== 'object' || obj === null) return obj;

            if (Array.isArray(obj)) {
                return obj.map(item => this.convertBoolToYN(item));
            }

            const result = {};
            for (const [key, value] of Object.entries(obj)) {
                // Manejar campo status: true → "A", false → "I"
                if (key === 'status' && typeof value === 'boolean') {
                    result[key] = value ? 'A' : 'I';
                }
                // SOLO transforma si es booleano Y NO es status
                else if (typeof value === 'boolean') {
                    // ← Cambiado a else if
                    result[key] = value ? 'Y' : 'N';
                }
                // Si es un objeto (no null), lo procesa recursivamente
                else if (typeof value === 'object' && value !== null) {
                    result[key] = this.convertBoolToYN(value);
                }
                // CUALQUIER OTRO VALOR lo deja igual
                else {
                    result[key] = value;
                }
            }
            return result;
        },

        onCodeConditionOk(result) {
            if (!this.therapy) return;

            const type = result.FieldName;
            const { code, description } = result;

            const mapping = {
                category: { codeProp: 'category', descProp: 'categoryName' }
            };

            const key = Object.keys(mapping).find(k => type.includes(k));

            if (key) {
                const { codeProp, descProp } = mapping[key];
                this.therapy[codeProp] = code || '';
                this[descProp] = description || '';
            }
        },

        async getAllDescription() {
            if (!this.therapy) return;

            const getters = {
                category: {
                    codes: [this.therapy.category],
                    fetch: async code => {
                        const response = await TherapyCategoriesService.get(code);
                        return response.data?.name;
                    },
                    setter: value => {
                        this.categoryName = value;
                    }
                }
            };
            // Ejecutar todas las peticiones en paralelo
            await Promise.allSettled(
                Object.values(getters).flatMap(({ codes, fetch, setter }) =>
                    codes.filter(Boolean).map(async code => {
                        try {
                            const value = await fetch(code);
                            if (value) setter(value);
                        } catch (error) {
                            this.showResponseErrorMessage(error);
                        }
                    })
                )
            );
        },

        toggleSelectAll(selected) {
            if (selected) {
                this.selectedOptions = this.options.map(option => option.value);
            } else {
                this.selectedOptions = [];
            }
            this.updtWeekStatus();
        },

        async updtWeekStatus() {
            const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
            days.forEach(day => {
                const key = day.toLowerCase().slice(0, 3);
                this.therapy[key] = this.selectedOptions.includes(day) ? 'Y' : 'N';
            });
        },
        // Method to update the status of "Select All"
        updateSelectAll() {
            this.updtWeekStatus();
        },

        beforeWindowUnload(e) {
            if (this.pendingChanges) {
                e.preventDefault();
                e.returnValue = '';
            }
        },

        checkUserAction() {
            if (elemSaveBtn && elemSaveBtn.disabled) {
                elemSaveBtn.removeAttribute('disabled');
            }
        },

        async getAllEmployee() {
            await EmployeeService.getEmployeeLookup()
                .then(response => {
                    if (response.data && response.data.length > 0) {
                        this.TherapistList = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async ExecuteAllCalls() {
            await this.getAllEmployee();
            await this.getTherapy();
        },

        addHandler() {
            this.editableItemIndex = -1;
            this.visibleEditDialog = true;
        },

        okHandler() {
            this.visibleEditDialog = false;
            const editableItemCloned = { ...this.editableItem };
            if (this.editableItemIndex !== -1) {
                this.$set(
                    this.therapy.therapyBillingCodes,
                    this.editableItemIndex,
                    editableItemCloned
                );
            } else {
                this.therapy.therapyBillingCodes.push(editableItemCloned);
            }
            this.editableItem = null;
            const changed = {
                Changed: true
            };
            EventBus.$emit('onChanged', changed);
        },

        closeHandler() {
            this.visibleEditDialog = false;
            this.editableItem = null;
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        pageChanged(page) {
            this.currentPage = page;
        },

        PerPageFunction(perpage) {
            this.perPage = perpage;
            if (this.currentPage > this.totalRows / this.perPage) {
                this.currentPage = 1;
            }
        },

        onRowSelected() {},

        rowClickHandler() {},

        RemoveBillingCode(itemToRemove) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$tc('Shared.DelRecord'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning',
                    id: 'modal_delete_document'
                })
                .then(value => {
                    if (value) {
                        const index = this.therapy.therapyBillingCodes.findIndex(
                            item => item === itemToRemove
                        );

                        if (index !== -1) {
                            this.therapy.therapyBillingCodes.splice(index, 1);
                            const changed = {
                                Changed: true
                            };
                            EventBus.$emit('onChanged', changed);

                            if (this.currentPage > this.totalRows / this.perPage) {
                                this.currentPage--;
                            }
                        }
                    }
                });
        },

        EditBillingCode(item) {
            this.editableItemIndex = this.therapy.therapyBillingCodes.indexOf(item);
            this.editableItem = item;
            this.visibleEditDialog = true;
        },

        // Método para enriquecer todos los billing codes en paralelo
        async enrichBillingCodesWithDescriptions(billingCodes) {
            if (!billingCodes || billingCodes.length === 0) return [];

            // Crear array de promesas para procesar cada billing code
            const enrichmentPromises = billingCodes.map(async billingCode => {
                // Crear una copia para no modificar el original directamente
                const enrichedItem = { ...billingCode };

                try {
                    // Obtener todas las descripciones para este billing code
                    await this.enrichSingleBillingCode(enrichedItem);
                } catch (error) {
                    console.error(
                        `Error en billing code ${billingCode.id || billingCode.code}:`,
                        error
                    );
                    // No fallar todo por un item
                }

                return enrichedItem;
            });

            // Esperar a que todas las promesas se resuelvan
            return await Promise.all(enrichmentPromises);
        },

        // Método para enriquecer un solo billing code
        async enrichSingleBillingCode(item) {
            // Definir las configuraciones de cada campo a enriquecer
            const enrichmentConfigs = [
                {
                    codeField: 'insuranceCode',
                    descField: 'insuranceName',
                    service: InsuranceService.getInsuranceByCode,
                    extractor: response => response?.data?.company
                },
                {
                    codeField: 'hcPcsCode',
                    descField: 'dhcpcs',
                    service: CptService.getCPTByCode,
                    extractor: response => response?.data?.[0]?.name,
                    needsParameter: true
                },
                {
                    codeField: 'cpt',
                    descField: 'dcpt',
                    service: CptService.getCPTByCode,
                    extractor: response => response?.data?.[0]?.name,
                    needsParameter: true
                },
                {
                    codeField: 'modifier1',
                    descField: 'dmodifier1',
                    service: ModifierService.getModifierByCode,
                    extractor: response => response?.data?.[0]?.description,
                    needsParameter: true
                },
                {
                    codeField: 'modifier2',
                    descField: 'dmodifier2',
                    service: ModifierService.getModifierByCode,
                    extractor: response => response?.data?.[0]?.description,
                    needsParameter: true
                },
                {
                    codeField: 'modifier3',
                    descField: 'dmodifier3',
                    service: ModifierService.getModifierByCode,
                    extractor: response => response?.data?.[0]?.description,
                    needsParameter: true
                },
                {
                    codeField: 'modifier4',
                    descField: 'dmodifier4',
                    service: ModifierService.getModifierByCode,
                    extractor: response => response?.data?.[0]?.description,
                    needsParameter: true
                },
                {
                    codeField: 'valueCode',
                    descField: 'dvalCode',
                    service: ValueCodeService.getValueCodeByCode,
                    extractor: response => response?.data?.[0]?.shortDescription,
                    needsParameter: true
                },
                {
                    codeField: 'pos',
                    descField: 'dpos',
                    service: PlaceOfServiceService.getPlaceOfServiceByCode,
                    extractor: response => response?.data?.[0]?.description,
                    needsParameter: true
                }
            ];

            // Crear array de promesas para todas las descripciones
            const descriptionPromises = enrichmentConfigs.map(async config => {
                const codeValue = item[config.codeField];

                // Si no hay código, saltar
                if (!codeValue) return null;

                try {
                    let response;
                    if (config.needsParameter) {
                        // Servicios que necesitan un objeto parámetro
                        const parameter = { code: codeValue };
                        response = await config.service(parameter);
                    } else {
                        // Servicios que reciben el código directamente
                        response = await config.service(codeValue);
                    }

                    const description = config.extractor(response);
                    if (description) {
                        // Asignar la descripción al item
                        this.$set(item, config.descField, description);
                    }

                    return { field: config.descField, value: description };
                } catch (error) {
                    console.error(`Error obteniendo ${config.descField} para ${codeValue}:`, error);
                    return null;
                }
            });
            // Esperar a que todas las descripciones se resuelvan
            await Promise.allSettled(descriptionPromises);
        },

        findBilling() {
            this.search.billing = this.searchBill;
            this.currentPage = 1;
        },

        getInsuranceCodeValues(value) {
            this.search.insurance = value.code;
            this.searchInsuranceName = value.description;
        },

        changeDropDownStatus(value) {
            this.search.status = value ? value.value : '';
        },

        changeDropDownNoteStatus(value) {
            this.therapy.noteStatus = value ? value.code : '';
        },

        Accordion1Click() {
            this.ShowFilter = !this.ShowFilter;
            this.ShowBilling = !this.ShowBilling;
        },

        ClickBtnAccordion2() {
            this.ShowFilter = !this.ShowFilter;
            this.ShowBilling = !this.ShowBilling;
        },

        isValidDate(element, item) {
            const sourceStartDate = item.startDate ? moment(item.startDate) : moment('12/30/1899');
            const sourceEndDate = item.endDate ? moment(item.endDate) : moment('12/31/9999');
            const savedStartDate = element.startDate
                ? moment(element.startDate)
                : moment('12/30/1899');
            const savedEndDate = element.endDate ? moment(element.endDate) : moment('12/31/9999');

            return (
                sourceStartDate.isBetween(savedStartDate, savedEndDate) ||
                sourceEndDate.isBetween(savedStartDate, savedEndDate) ||
                (sourceStartDate <= savedStartDate && sourceEndDate >= savedEndDate)
            );
        },

        checkOverlapping(item) {
            let isValid = true;
            const list = this.therapy?.therapyBillingCodes || [];

            if (this.editableItemIndex === -1) {
                isValid =
                    list.find(element => {
                        const insuranceCode = (item.insuranceCode || '').trim();
                        const hcPcsCode = (item.hcPcsCode || '').trim();
                        const modifier1 = (item.modifier1 || '').trim();
                        const modifier2 = (item.modifier2 || '').trim();

                        return (
                            element.cpt === item.cpt &&
                            element.status === item.status &&
                            (element.insuranceCode || '') === insuranceCode &&
                            (element.hcPcsCode || '') === hcPcsCode &&
                            (element.modifier1 || '') === modifier1 &&
                            (element.modifier2 || '') === modifier2 &&
                            this.isValidDate(element, item)
                        );
                    }) === undefined;
            } else {
                isValid =
                    list.find(element => {
                        const insuranceCode = (item.insuranceCode || '').trim();
                        const hcPcsCode = (item.hcPcsCode || '').trim();
                        const modifier1 = (item.modifier1 || '').trim();
                        const modifier2 = (item.modifier2 || '').trim();

                        return (
                            element.recordId !== item.recordId &&
                            element.cpt === item.cpt &&
                            element.status === item.status &&
                            (element.insuranceCode || '') === insuranceCode &&
                            (element.hcPcsCode || '') === hcPcsCode &&
                            (element.modifier1 || '') === modifier1 &&
                            (element.modifier2 || '') === modifier2 &&
                            this.isValidDate(element, item)
                        );
                    }) === undefined;
            }

            if (!isValid) {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('therapyDlg.OverlappingError'),
                    'errorAutoHide'
                );
            }

            return !isValid;
        }
    },

    async mounted() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        const allPromise = Promise.all([await this.ExecuteAllCalls()]);
        await allPromise.then(() => {
            this.getAllDescription();
        });

        setTimeout(
            function() {
                elemSaveBtn = document.getElementById('btn_save_inventory_item');
                elemSaveBtn.setAttribute('disabled', '');
            },
            50,
            this
        );
    },

    created() {
        EventBus.$on(
            'onChanged',
            function(e) {
                this.pendingChanges = e.Changed;
                this.checkUserAction();
            }.bind(this)
        );

        window.addEventListener('beforeunload', this.beforeWindowUnload);
    },

    destroyed() {
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    },

    beforeDestroy() {
        EventBus.$off('onChanged');
        window.removeEventListener('beforeunload', this.beforeWindowUnload);
    }
};
</script>
